import { createFileRoute, redirect } from '@tanstack/react-router'
import { LoginForm } from '../../components/LoginForm'
import { AuthLayout } from '../../components/auth/AuthLayout'
import { validateLoginSearch } from '../../lib/login-search'

// The org-scoped login page (spec 2026-10-14-22). Without `next` it is only a
// hint: it hands over to the org-less /login with `next=/<org>`, keeping every
// other search param (the demo link's email/password, an SSO callback's
// tokens, an MFA challenge). With `next` (a session-expired link, the auth
// guard) it renders as before, hinting its own organization.
export const Route = createFileRoute('/$org/login')({
  component: Login,
  validateSearch: validateLoginSearch,
  beforeLoad: ({ search, params }) => {
    if (!search.next) {
      throw redirect({ to: '/login', search: { ...search, next: `/${params.org}` }, replace: true })
    }
  },
})

function Login() {
  return (
    <AuthLayout>
      <LoginForm />
    </AuthLayout>
  )
}
